import React from 'react';
import styled from 'styled-components';

import CuiPali from '../img/CuidadosPaliativos.png';


const Podcast = () => {
    return (
        
        <Contenedor>
            <HEADER>
                <h1>Podcast</h1>
            </HEADER>

            <HEADER2>
                <p>De acuerdo con la OPS:</p>
            </HEADER2>
            
            <TEXT>
                <p>Los cuidados paliativos son un enfoque para mejorar la calidad de vida de los pacientes y sus familias que 
                    enfrentan los problemas asociados con enfermedades potencialmente mortales. Incluye la prevención y el alivio 
                    del sufrimiento mediante la identificación temprana, evaluación y tratamiento del dolor y otros problemas físicos, 
                    psicosociales y espirituales.</p>
            </TEXT>
            <TEXT>
                <p>Se estima que 40 millones de personas en el mundo necesitan cuidados paliativos cada año, debido al envejecimiento 
                    de la población y al aumento de enfermedades crónicas y no transmisibles. </p>                    
            </TEXT>
            
            <CuidPali src={CuiPali} />

            <HEADER>
                <h1>En TANCU</h1>
            </HEADER>

            <TEXT>
                <p>Los cuidados paliativos mejoran la calidad de vida de los pacientes y las familias que se enfrentan con 
                    enfermedades amenazantes para la vida, mitigando el dolor y otros síntomas, y proporcionando apoyo espiritual 
                    y psicológico desde el momento del diagnóstico hasta el final de la vida y durante el duelo.</p>                    
            </TEXT>
        </Contenedor>
    );
}

const Contenedor = styled.div`
    width: 100%;
    max-width: 1000px;
    padding: 0rem 2rem;
    background: #00fff;
    
    
    
    @media (max-width: 420px) { 
        width: 100%;
        // max-width: 520px;
        font-size: 20px;
        color: #092c4c;
        background: #00fff;
        // padding: 0rem 10rem 0rem 0rem
      }
`;
const HEADER = styled.div`
    width: 100%;
    margin: 2rem 0rem 2rem 0rem;    
    text-decoration: underline #092c4c;

    @media (max-width: 420px) { 
        font-size: 12px;
      }
`;
const TEXT = styled.div`
    width: 100%;
    margin: 2rem 0rem 2rem 0rem;    
    text-decoration: #092c4c;

    @media (max-width: 420px) { 
        font-size: 12px;
      }
`;
const CuidPali = styled.img`
    width: 90%;
    height: 80%;
    padding: 2rem 1rem 2rem 3rem;
    border-radius: 60px;
    @media (max-width: 420px) { 
        width: 80%;
        height: 70%;
      }
`;

const HEADER2 = styled.div`
    width: 100%;
    margin: 2rem 0rem 2rem 0rem;    
    font-size: 26px;

    @media (max-width: 420px) { 
        font-size: 18px;
      }
`;
export default Podcast;